<template>
    <div class="demand-details demand-details-card">

        <div style="background-color: #fff; padding: 1rem;">
            <div class="ft-notification" style="margin-top: -1rem; margin-bottom: 0.5rem;" v-if="item.demand_status_details!==null&&item.demand_status_details.status == 'OPEN' && item.demand_status_details.rate != null && item.demand_status_details.trucks_supplied != null">
                <status-banner :data="item"/>
            </div>
            <b-row class="route-section">
                <b-col cols="12" class="ft-route-details">
                    <h4 class="ft-route">
                    {{ item.origin }} - {{ item.destination }}
                    </h4>
                </b-col>
                <!-- <b-col cols="4" class="ft-end-time">
                    <p class="ft-route-time small-text">{{ bidReminingTime + ' Left' }}</p>
                </b-col> -->
            </b-row>

            <b-row class="vehicle-material-details">
                <b-col cols="7">
                    <h6 class="ft-vehicle">
                    <icon-base icon-name="truck" width="20" height="16">
                        <icon-truck/>
                    </icon-base>
                    <span>{{ vehicleDetail }}</span>
                    </h6>
                    <span class="small-text grey-text-1 pdl-38">{{ item.truck_size }}</span>
                </b-col>
                <b-col cols="5" v-if="item.material">
                    <h6 class="ft-material">
                    <icon-base icon-name="material" width="15" height="20">
                        <icon-material/>
                    </icon-base>
                    <span>{{ item.material }}</span>
                    </h6>
                </b-col>
                <b-col cols="12" v-if="bidPlacedByCurrentSupplier">
                    <h6 class="bid-price">
                        <icon-base icon-name="material" width="20" height="24" viewbox="0 0 24 20">
                            <icon-pay/>
                        </icon-base>
                        <span v-if="item.demand_status_details!==null">{{ $t('message.bidValueText') + item.demand_status_details.rate }}</span>
                    </h6>
                </b-col>
                <b-col cols="12" v-if="!bidPlacedByCurrentSupplier && !editMode">
                    <b-button class="bid-now-btn mt-3" block variant="secondary" @click="onClickBidNow" style="width:100%;">
                    {{ $t('message.placeBidBtnText') }}
                    </b-button>
                </b-col>
                 <b-col cols="12" v-if="item.demand_status_details!==null&&item.demand_status_details.is_edit_allowed">
                    <b-button class="bid-now-btn mt-3" block variant="outline-secondary" @click="onClickBidNow" style="width:100%;background: #fff; color: #000000">
                    {{ $t('message.editBid')  }}
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import IconBase from '../components/IconBase.vue'
import IconTruck from '../components/icons/IconTruck.vue'
import IconMaterial from '../components/icons/IconMaterial.vue'
import IconPay from '../components/icons/IconPay.vue'
import StatusBanner from './StatusBanner.vue'
import moment from 'moment'


export default {
    name: "DemandDetailsCard",
    components: {
        IconBase,
        IconTruck,
        IconMaterial,
        IconPay,
        StatusBanner
    },
    props: {
        item: Object
    },
    data() {
        return {
            editMode: false
        }
    },
    methods: {
        onClickBidNow() {
            this.$emit('click-bid-now', this.item)
        }

    },
    computed: {
        vehicleDetail: function () {
            return this.item.trucks_required + ' x ' + this.item.truck_type
        },
        bidReminingTime: function() {
            const time = (this.item) ? moment(this.item.expected_reporting_date || new Date()).fromNow('m') : ''
            return time
        },
        bidPlacedByCurrentSupplier: function() {
            let flag = false;
            const {demand_status_details} = this.item;
            if (demand_status_details!==null&&demand_status_details.status == 'OPEN' && demand_status_details.rate != null && demand_status_details.trucks_supplied != null) {
                flag = true
            }
            return flag
        }

    }

}
</script>

<style lang=scss>
.demand-details {
    &.demand-details-card {
    padding-bottom: 0.5rem;
    background-color: #E5E5E5 !important;
    }
}
/* .route-section {
    margin-top: 1rem;
} */
.bid-now-btn {
    background-color: #1F1F1F;
}

.bid-price {
    padding-top: 1rem;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #1F1F1F
}
</style>
